import { useCurrentUser } from "@legacy-megarax/react-client";
import { Navigate } from "react-router-dom-v5-compat";
import { getMegaraxPath } from "@megaron/megarax-uri";

export const MyVisitsRedirect = () => {
  const currentUser = useCurrentUser();

  if (currentUser) {
    return (
      <Navigate
        to={getMegaraxPath.uri("megarax://crm/salesperson-visits/id/{id}/{view}", {
          id: String(currentUser.id),
          view: "day",
        })}
      />
    );
  }

  return null;
};
